import React from 'react';
import TrafalgarLogo from './TrafalgarLogo';

const StartMenu = ({ isOpen, windowData, onWindowClick }) => {
  const menuItems = [
    { id: 'about', icon: '📋', label: 'About Trafalgar' },
    { id: 'oscp', icon: '⚙️', label: 'OSCP Overview' },
    { id: 'products', icon: '🚀', label: 'Products & Solutions' },
    { id: 'contact', icon: '📧', label: 'Contact Us' }
  ];

  const systemItems = [
    { icon: '💻', label: 'System Information' },
    { icon: '⚙️', label: 'Settings' }
  ];

  return (
    <div 
      className={`start-menu ${isOpen ? 'show' : ''}`} 
      id="start-menu" 
      role="menu"
    >
      <div className="start-menu-header">
        <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
          <div style={{ width: '32px', height: '32px' }}>
            <TrafalgarLogo />
          </div>
          <span style={{ fontSize: '18px', fontWeight: '600' }}>Trafalgar</span>
        </div>
      </div>
      
      <div className="start-menu-content">
        {menuItems.map(item => (
          <div
            key={item.id}
            className="start-menu-item"
            onClick={() => onWindowClick(item.id)}
            onKeyDown={(e) => {
              if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                onWindowClick(item.id);
              }
            }}
            tabIndex="0"
            role="menuitem"
          >
            <span>{item.icon}</span>
            <span>{item.label}</span>
          </div>
        ))}
        
        <hr style={{ margin: '16px 0', border: 'none', borderTop: '1px solid #ddd' }} />
        
        {systemItems.map((item, index) => (
          <div
            key={index}
            className="start-menu-item"
            onKeyDown={(e) => {
              if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                // Handle system item click
              }
            }}
            tabIndex="0"
            role="menuitem"
          >
            <span>{item.icon}</span>
            <span>{item.label}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default StartMenu;
